export const googleTagManagerId = 'GTM-MRZ8NJL';

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export const pushGtmEvent = (event: string, params?: Record<string, unknown>) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({
    ...params,
    event,
  });
};
